import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { MarketList } from '../models/market.model';

@Injectable({
  providedIn: 'root'
})
export class MarketService{
   baseMarketUrl = environment.baseUrl;
    constructor(private http: HttpClient) { }

    getMarketList():Observable<MarketList[]> {
      var url = `${this.baseMarketUrl}markets`;
      return this.http.get<MarketList[]>(url);
    }

    createMarket(formData:any):Observable<any> {
      var url = `${this.baseMarketUrl}markets`;
       return this.http.post<any>(url,formData);
    }
    deleteMarket( id: any): Observable<any> {      
      const url = `${this.baseMarketUrl}markets`;
      return this.http.delete(`${url}?id=${id}`);
    }
}
